import $ from 'jquery';

class Modal {
    constructor() {
        this.popup = $('.modal');
        this.popupContent = $('.modal__content');
        this.openButton = $('.js-popup');
        this.closeButton = $('.modal__close');
        this.events();
    }

    events() {

        //open popup when click on popup trigger button
        $(document).click(e => {
            var attr = $(e.target).attr('data-modal'),
                id;

            if (attr) {
                e.preventDefault();
                id = '#' + attr;
                if (!this.isPopupActive(id)) {
                    this.openPopup(id);
                }
            }else {
                $(this.popup).removeClass('modal--show').fadeOut();
            }
        })

        //close popup
        $(this.closeButton).on('click', function () {
            $(this).parents('.modal').fadeOut().removeClass('modal--show');
        })

        //prevent closing when click out side of popup
        $(this.popupContent).on('click', function (e) {
            e.stopPropagation();
        })

    }

    //open popup
    openPopup(id) {
        $(id).addClass('modal--show').fadeIn();
    }

    //Close popup
    closePopup(id) {
        $(id).removeClass('modal--show').fadeOut();
    }

    isPopupActive(id) {
        return $(id).hasClass('modal--show');
    }

}

export default Modal;